module.exports = __webpack_public_path__ + "img/xfz_question_creation.e8210b2b.png";